import type { ReactNode } from 'react';

export const symbol_siren: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-180h680v-105H140v105Zm247-382.5q0-38.57 27-66.03Q441-656 480-656q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5-64 0-108.5 45.24Q327-625.53 327-562v93q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-93.5ZM480-285Zm-217-60h434v-217.5q0-90.26-63-153.88Q571-780 480-780t-154 63.62q-63 63.62-63 153.88V-345ZM140-120q-24.75 0-42.37-17.63Q80-155.25 80-180v-105q0-24.75 17.63-42.38Q115.25-345 140-345h63v-217q0-115 81-196.5T480-840q115 0 196 81.5T757-562v217h63q24.75 0 42.38 17.62Q880-309.75 880-285v105q0 24.75-17.62 42.37Q844.75-120 820-120H140Zm340-225Z"
		/>
	</svg>
);
